import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Center, Flex, Icon } from '@chakra-ui/react';
import { NotificationTime } from '../../components/Time';
import { Calendar } from '@kula-ai/icons/outline/Calendar';
import {
  GoToInterviewButton,
  MeetingDetailsContainer,
  NotificationMessage,
} from './components';

const SentAMessage = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const { interview_url, sender, interview_name, candidate } = data;
  const { name: candidate_name, url: candidate_url } = candidate;
  const interview_id = interview_url.split('/').pop();
  const contact_id = candidate_url.split('/').pop();

  const messageData = {
    interviewer: { name: sender?.name },
    interview: { name: interview_name, url: `/interviews/${interview_id}` },
    candidate: { name: candidate_name, url: `/candidates/${contact_id}` },
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <Icon as={Calendar} color="primary-500" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <NotificationMessage
          template="MESSAGE_RECEIVED"
          data={messageData}
          onClose={onClose}
          notification={notification}
        />
        <MeetingDetailsContainer
          data={data}
          isCollapsable={false}
          skipInterviewers
          skipMeetingRooms
          showMessage
          skipLocation
          interviewSectionOrder
        />
        <Flex flexDir="column" gap="6px">
          <GoToInterviewButton
            interviewUrl={interview_url}
            notification={notification}
          />
        </Flex>
        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const SentAMessageNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <SentAMessage notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
